import { createContext, useContext, useState, useEffect } from "react";
import { useWebSocketContext } from "../WebSocketProvider";

const EnergyContext = createContext();

export const EnergyProvider = ({ children }) => {
  const { send, registerHandler } = useWebSocketContext();
  const [totalEnergy, setTotalEnergy] = useState(0);

  useEffect(() => {
    const unregister = registerHandler("cms_get_total_energy_consumed_by_group_id_response", (msg) => {
      setTotalEnergy(msg.totalEnergy || 0);
    });
    return unregister;
  }, [registerHandler]);

  const fetchTotalEnergy = (groupId) => send("cms_get_total_energy_consumed_by_group_id_response", { group_id: groupId });

  return (
    <EnergyContext.Provider value={{ totalEnergy, fetchTotalEnergy }}>
      {children}
    </EnergyContext.Provider>
  );
};

export const useEnergy = () => useContext(EnergyContext);